import Cover from './Cover';
export default Cover;